// extracted by mini-css-extract-plugin
export default {"DocumentInfo":"DocumentInfo_DocumentInfo__bPn1J"};